import { FunctionComponent } from 'react';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { AdvertisementBrick } from './AdvertisementBrick';
import { isNotNullOrUndefinedValue } from '../../../helpers/isNotNullOrUndefinedValue';

export const AdvertisementBrickWithData: FunctionComponent = () => {
  const advertisement = usePropertyPageQuery()?.data?.propertyPageBySlugV3?.advertisement;

  if (!isNotNullOrUndefinedValue(advertisement)) return null;

  return <AdvertisementBrick variant={advertisement.variant} key={advertisement.key} />;
};
